module.exports = __webpack_public_path__ + "dgrid-white-bg.1H9HFZvZ.png";